var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-item"},[_c('div',{staticClass:"profile-item__element profile-item__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"profile-item__element profile-item__value"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }